import { render } from "./GallerySection.vue?vue&type=template&id=88bde39e&scoped=true"
import script from "./GallerySection.vue?vue&type=script&lang=js"
export * from "./GallerySection.vue?vue&type=script&lang=js"

import "./GallerySection.vue?vue&type=style&index=0&id=88bde39e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88bde39e"]])

export default __exports__